import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox, FormControlLabel } from '@mui/material'

/**
 * Shared MUI Checkbox wrapper component
 * Replaces muicss Checkbox pattern
 */
export default function MuiCheckbox ({
  label,
  name,
  value,
  checked,
  onChange,
  className,
  disabled = false,
  required = false,
  ...otherProps
}) {
  return (
    <FormControlLabel
      control={
        <Checkbox
          name={name}
          value={value}
          checked={checked || false}
          onChange={onChange}
          disabled={disabled}
          required={required}
          {...otherProps}
        />
      }
      label={label}
      className={className}
    />
  )
}

MuiCheckbox.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number,
    PropTypes.object,
  ]),
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
}
